import MapaInterativo from '~/Components/Mapa/MapaInterativo';
import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import * as api from '~/Services/Service';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import LotesVendas from '~/Components/Mapa/LotesVendas';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import {
  StatusImovel,
  EMPREENDIMENTO_LANCAMENTO,
  caracteristicas,
} from '~/constant';
import ModalFiltro from '~/Components/Mapa/ModalFiltro';
import { FaFilter, FaFileExcel, FaMapMarkedAlt, FaCloudUploadAlt, FaTrash } from 'react-icons/fa';
import Dropzone from 'react-dropzone';
import ModalReserva from '~/Components/Mapa/ModalReserva';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthStorage from '~/Utils/AuthStorage';
import ModalMapaSelecao from '~/Components/ModalMapaSelecao/ModalMapaSelecao';
import useDynamicSvg from '~/hooks/useDynamicSvg';

const mapaHumanizado = () => {
  const { codigo } = useParams();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prospectoUrl = queryParams.get('prospecto') || '';
  const [prospectoInicial, setProspectoInicial] = useState(prospectoUrl);
  const empreendimentos = useSelector(state => state.empreendimentos);

  const [ativos, setAtivos] = useState([]);
  const [ativosReservadosF1, setAtivosReservadosF1] = useState([]);
  const [informacoesDizeres, setInformacoesDizeres] = useState({
    fase1Disponiveis: 0,
    fase2Disponiveis: 0,
    bloqueados: 0,
    vendidos: 0,
    reservados: 0,
    preVendas: 0,
  });

  // Inicializa codigoFamilia: URL > (somente atendente de lançamento) user/global > null
  const [codigoFamilia, setCodigoFamilia] = useState(() => {
    if (codigo) return codigo;
    if (AuthStorage.isAtendenteLancamento()) {
      const user = AuthStorage.getUser();
      return (user && user.empreendimento_lancamento) || EMPREENDIMENTO_LANCAMENTO || null;
    }
    return null;
  });

  const empreendimentoAtual = empreendimentos.byId[codigoFamilia];
  const nomeEmpreendimento = empreendimentoAtual ? empreendimentoAtual.descricao : '';
  const [loading, setLoading] = useState(true);

  const { svgContent, loading: svgLoading, error: svgError } = useDynamicSvg(codigoFamilia);

  const svgData = useMemo(() => {
    if (!svgContent) return null;
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgContent, 'image/svg+xml');
    const svgEl = doc.querySelector('svg');
    if (!svgEl) return null;
    return {
      viewBox: svgEl.getAttribute('viewBox'),
      innerHTML: svgEl.innerHTML,
    };
  }, [svgContent]);
  const [showModal, setShowModal] = useState(false);
  const [ativosFiltrados, setAtivosFiltrados] = useState([]);
  const [mostrarModalPlanilha, setMostrarModalPlanilha] = useState(false);
  const [enviandoPlanilha, setEnviandoPlanilha] = useState(false);
  const [mostrarModal, setMostarModal] = useState(false);
  const [ativoFiltrado, setAtivoFiltrado] = useState(null);
  const [quadraFiltrada, setQuadraFiltrada] = useState(null);
  const [loteFiltrado, setLoteFiltrado] = useState(null);
  const [arquivosParaEnvio, setArquivosParaEnvio] = useState([]);
  const arquivoRef = React.createRef();
  const [logsCarga, setLogsCarga] = useState(null);

  // Abre automaticamente quando não há codigo na URL e o usuário não é atendente de lançamento
  const [modalMapaSelecao, setModalMapaSelecao] = useState({
    show: !codigo && !AuthStorage.isAtendenteLancamento(),
  });

  const mesclarArquivos = novos => {
    setArquivosParaEnvio(prev => {
      const existentes = new Set(prev.map(a => `${a.name}-${a.size}`));
      const unicos = novos.filter(a => !existentes.has(`${a.name}-${a.size}`));
      return prev.concat(unicos);
    });
  };

  const adicionarArquivo = e => {
    const arquivos = Array.from(e.target.files || []);
    if (arquivos.length > 0) {
      mesclarArquivos(arquivos);
    }
  };

  const onDropArquivo = aceitos => {
    if (aceitos && aceitos.length > 0) {
      mesclarArquivos(aceitos);
    }
  };

  const removerArquivo = index => {
    setArquivosParaEnvio(prev => prev.filter((_, i) => i !== index));
    if (arquivoRef.current) arquivoRef.current.value = '';
  };

  const removerTodos = () => {
    setArquivosParaEnvio([]);
    if (arquivoRef.current) arquivoRef.current.value = '';
  };

  const dropzoneStyle = isDragActive => ({
    border: `2px dashed ${isDragActive ? '#007bff' : '#ccc'}`,
    borderRadius: 4,
    padding: 24,
    textAlign: 'center',
    cursor: 'pointer',
    background: isDragActive ? '#f0f7ff' : '#fafafa',
    transition: 'border-color .15s, background .15s',
  });

  const habilitarDesabilitarModalPlanilha = () => {
    setMostrarModalPlanilha(!mostrarModalPlanilha);
  };

  const salvarPlanilha = async () => {
    try {
      setEnviandoPlanilha(true);
      const formData = new FormData();
      arquivosParaEnvio.forEach(arquivo => {
        formData.append(arquivo.name, arquivo);
      });
      const response = await api.EnviarPlanilhaCargaLancamento(formData);
      if (response) {
        setLogsCarga(response.logs);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setEnviandoPlanilha(false);
    }
  };

  const handleApplyFilters = (filtrados, informouQudra) => {
    setAtivosFiltrados(filtrados);
    if (filtrados.length === 1) {
      setLoteFiltrado(filtrados[0].codigo);
      habiliarModalPorFiltro(filtrados);
    } else if (informouQudra && filtrados.length > 1) {
      setQuadraFiltrada(filtrados[0].codigo);
    }
  };

  useEffect(() => {
    if (codigoFamilia) {
      // Sincroniza URL se entrou sem código na rota (ex: auto-load por lançamento)
      if (!codigo) {
        history.replace(`/mapa/${codigoFamilia}`);
      }

      setLoading(true);
      setAtivosFiltrados([]);
      const fetchData = async () => {
        await Promise.all([fetchFamilias(), fetchLotesReservados()]);
        setLoading(false);
      };
      fetchData();

      if (!prospectoUrl && AuthStorage.isAtendenteLancamento()) {
        api.buscarAtendimentoAtual(codigoFamilia)
          .then(response => {
            if (response && response.codigo_prospecto) {
              setProspectoInicial(String(response.codigo_prospecto));
            }
          })
          .catch(() => {});
      }
    }
  }, [codigoFamilia]);

  const habiliarModalPorFiltro = filtrados => {
    setMostarModal(true);
    const objetoFiltrado = ativos.filter(
      a => a.codigo === filtrados[0].codigo
    )[0];
    setAtivoFiltrado(objetoFiltrado);
  };

  const handleOpenModal = () => {
    setAtivosFiltrados([]);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const fetchFamilias = async () => {
    try {
      const ativos = await api.buscarFamiliaLancamento(codigoFamilia);
      setAtivos(ativos);
    } catch (error) {
      toast.error(error.message || 'Erro ao buscar famílias');
    }
  };

  const fetchLotesReservados = async () => {
    try {
      const ativosReservadosF1 = await api.listarLotesReservados(codigoFamilia);
      setAtivosReservadosF1(ativosReservadosF1);
    } catch (error) {
      console.error('Erro ao buscar lotes reservados:', error);
      setAtivosReservadosF1([]);
    }
  };

  useEffect(() => {
    if (ativos) {
      const countLotes = ativos.reduce(
        (acc, ativo) => {
          switch (ativo.status) {
            case StatusImovel.Disponivel:
              acc.fase1Disponiveis += 1;
              break;
            case StatusImovel.Bloqueado:
              acc.bloqueados += 1;
              break;
            case StatusImovel.Vendido:
              acc.vendidos += 1;
              break;
            case StatusImovel.PreVenda:
              acc.vendidos += 1;
              break;
            case StatusImovel.Reservado:
              if (ativo.rodada_negocio) {
                acc.rodada_negocio += 1;
                break;
              }
              acc.reservados += 1;
              break;
            default:
              break;
          }
          return acc;
        },
        {
          fase1Disponiveis: 0,
          fase2Disponiveis: 0,
          bloqueados: 0,
          vendidos: 0,
          reservados: 0,
          rodada_negocio: 0,
        }
      );

      setInformacoesDizeres(countLotes);
    }
  }, [ativos]);

  // Ao selecionar um mapa, navega para a URL com o código
  const handleChoseMap = codigo_familia => {
    setModalMapaSelecao({ show: false });
    history.push(`/mapa/${codigo_familia}`);
    setCodigoFamilia(codigo_familia);
  };

  // Ao fechar o modal sem selecionar, define um padrão
  const handleCloseModalMap = () => {
    setModalMapaSelecao({ show: false });
    var defaultCodigo = EMPREENDIMENTO_LANCAMENTO || '11455';
    history.push(`/mapa/${defaultCodigo}`);
    setCodigoFamilia(defaultCodigo);
  };

  // Abre o modal para trocar de mapa
  const handleAbrirSelecaoMapa = () => {
    setModalMapaSelecao({ show: true });
  };

  return (
    <>
      <ModalMapaSelecao
        show={modalMapaSelecao.show}
        onHide={handleCloseModalMap}
        onSelect={handleChoseMap}
      />
      {(loading || !svgData) && !modalMapaSelecao.show && codigoFamilia && (
        <div
          className="mx-auto mt-4 w-100 h-100"
          style={{ background: '#353535', color: '#fff' }}
        >
          <Loading label="Carregando mapa..." />
        </div>
      )}
      {ativos && !loading && svgData && (
          <Container
            fluid
            className="w-100 h-100 p-0 mt-3"
            style={{ background: '#353535' }}
          >
            {mostrarModal && (
              <ModalReserva
                mostrarModal={mostrarModal}
                setMostrarModal={setMostarModal}
                codigoAtivo={ativoFiltrado.codigo}
                ativo={ativoFiltrado}
                atualizarReservados={fetchLotesReservados}
                atualizarMapa={fetchFamilias}
                prospectoInicial={prospectoInicial}
              />
            )}

            <Row className="mr-0">
              <Col md={9}>
                <MapaInterativo
                  ativos={ativos}
                  atualizarMapa={fetchFamilias}
                  atualizarReservados={fetchLotesReservados}
                  ativosFiltrados={ativosFiltrados}
                  setAtivosFiltrados={setAtivosFiltrados}
                  quadraFiltrada={quadraFiltrada}
                  setQuadraFiltrada={setQuadraFiltrada}
                  loteFiltrado={loteFiltrado}
                  setLoteFiltrado={setLoteFiltrado}
                  codigoFamilia={codigoFamilia}
                  nomeEmpreendimento={nomeEmpreendimento}
                  onTrocarMapa={handleAbrirSelecaoMapa}
                  svgData={svgData}
                  prospectoInicial={prospectoInicial}
                />
                <div
                  style={{
                    position: 'fixed',
                    right: '30%',
                    bottom: '20px',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    zIndex: 1000,
                  }}
                >
                  <div
                    className="contadores-mapa"
                    style={{ backgroundColor: '#fecc66' }}
                  >
                    Disponíveis: {informacoesDizeres.fase1Disponiveis}
                  </div>
                  <div
                    className="contadores-mapa"
                    style={{ backgroundColor: '#ee7272d1' }}
                  >
                    Vendidos: {informacoesDizeres.vendidos}
                  </div>
                  <div
                    className="contadores-mapa"
                    style={{ backgroundColor: '#2088f8' }}
                  >
                    Em negociação PDF: {informacoesDizeres.rodada_negocio}
                  </div>
                  <div
                    className="contadores-mapa"
                    style={{ backgroundColor: '#9dcbfb' }}
                  >
                    Em negociação: {informacoesDizeres.reservados}
                  </div>
                  <div
                    className="contadores-mapa"
                    style={{ backgroundColor: 'black', color: 'white' }}
                  >
                    Bloqueados: {informacoesDizeres.bloqueados}
                  </div>
                  <div
                    className="contadores-mapa"
                    style={{ backgroundColor: 'grey', color: 'white' }}
                  >
                    Total: {ativos ? ativos.length : 0}
                  </div>
                </div>
              </Col>
              <Col md={3} className="mt-3">
                <div>
                  <Button
                    variant="primary"
                    onClick={handleOpenModal}
                    style={{
                      right: '1%',
                      top: '83px',
                      position: 'fixed',
                    }}
                  >
                    Filtrar <FaFilter />
                  </Button>
                  <ModalFiltro
                    show={showModal}
                    onHide={handleCloseModal}
                    ativos={ativos}
                    onApplyFilters={handleApplyFilters}
                  />
                </div>
                <div
                  className="d-flex flex-column justify-content-between"
                  style={{
                    right: '1%',
                    top: '130px',
                    position: 'fixed',
                    height: '75%',
                    width: '24%',
                  }}
                >
                  {ativosReservadosF1.length !== 0 && (
                    <LotesVendas
                      ativosReservados={ativosReservadosF1}
                      atualizarReservados={fetchLotesReservados}
                      atualizarMapa={fetchFamilias}
                      ativos={ativos}
                      setAtivosFiltrados={setAtivosFiltrados}
                    />
                  )}
                </div>
                {AuthStorage.temCaracteristica(
                  caracteristicas.TransfereReserva
                ) && (
                  <div
                    style={{
                      position: 'fixed',
                      bottom: '20px',
                      right: '1%',
                    }}
                  >
                    <Button
                      variant="success"
                      onClick={() => {
                        habilitarDesabilitarModalPlanilha();
                      }}
                    >
                      Inserir Planilha <FaFileExcel />
                    </Button>
                    <Modal
                      size="md"
                      show={mostrarModalPlanilha}
                      onHide={() => {
                        habilitarDesabilitarModalPlanilha();
                        if (!mostrarModal) {
                          setLogsCarga(null);
                          setArquivosParaEnvio([]);
                          if (arquivoRef.current) arquivoRef.current.value = '';
                        }
                      }}
                      backdrop="static"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {' '}
                          <span>Anexar Planilhas</span>{' '}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Dropzone
                          multiple
                          accept=".xls,.xlsx,.csv"
                          onDropAccepted={onDropArquivo}
                          disabled={enviandoPlanilha}
                        >
                          {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                              {...getRootProps()}
                              style={dropzoneStyle(isDragActive)}
                            >
                              <input {...getInputProps()} />
                              <FaCloudUploadAlt size={32} color="#666" />
                              <div className="mt-2">
                                {isDragActive ? (
                                  <span>Solte os arquivos aqui...</span>
                                ) : (
                                  <span>
                                    Arraste os arquivos até aqui ou clique para selecionar
                                  </span>
                                )}
                              </div>
                              <div className="text-muted" style={{ fontSize: 12 }}>
                                Formatos aceitos: .xls, .xlsx, .csv (vários arquivos)
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <input
                          type="file"
                          className="d-none"
                          name="UploadArquivo"
                          id="UploadArquivo"
                          accept=".xls,.xlsx,.csv"
                          multiple
                          ref={arquivoRef}
                          onChange={e => {
                            adicionarArquivo(e);
                          }}
                        />
                        {arquivosParaEnvio.length > 0 && (
                          <div className="mt-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <label className="mb-0">
                                Arquivos selecionados (
                                {arquivosParaEnvio.length})
                              </label>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={removerTodos}
                                disabled={enviandoPlanilha}
                              >
                                Remover todos
                              </Button>
                            </div>
                            <ul
                              className="list-group"
                              style={{ maxHeight: 200, overflowY: 'auto' }}
                            >
                              {arquivosParaEnvio.map((arquivo, index) => (
                                <li
                                  key={`${arquivo.name}-${arquivo.size}-${index}`}
                                  className="list-group-item d-flex justify-content-between align-items-center py-2"
                                >
                                  <span
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                    title={arquivo.name}
                                  >
                                    {arquivo.name}
                                  </span>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => removerArquivo(index)}
                                    disabled={enviandoPlanilha}
                                    title="Remover arquivo"
                                  >
                                    <FaTrash />
                                  </Button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {enviandoPlanilha && (
                          <div>
                            <Loading label="Realizando carga excel..." />
                          </div>
                        )}
                        {logsCarga && logsCarga.length > 0 && (
                          <div>
                            <hr />
                            <label>Resultados:</label>
                            <div
                              className="mt-1"
                              style={{
                                border: '1px solid #ccc',
                                borderRadius: 4,
                                padding: 8,
                                fontFamily: 'monospace',
                                whiteSpace: 'pre-wrap',
                                maxHeight: 300,
                                overflowY: 'auto',
                              }}
                            >
                              {logsCarga.map((linha, i) => (
                                <span
                                  key={i}
                                  style={{
                                    display: 'block',
                                    color: linha.toLowerCase().includes('erro')
                                      ? 'red'
                                      : 'green',
                                    fontSize: 12,
                                  }}
                                >
                                  {linha}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          size={'md'}
                          variant="success"
                          onClick={() => {
                            salvarPlanilha();
                          }}
                          disabled={
                            arquivosParaEnvio.length === 0 || enviandoPlanilha
                          }
                        >
                          <span>Enviar</span>
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
      )}
    </>
  );
};

export default mapaHumanizado;